/**
 * Polished error state shared by every failure case (see src/api/apiError.js
 * for the 5 error kinds). Only ever shows the pre-written friendly copy —
 * never a raw status code, backend message, or stack trace.
 *
 * `onRetry` is omitted by the caller for non-retryable kinds (incomplete /
 * not_found), so no dead-end "Try again" button is shown for those.
 */
export default function CeremonyError({ error, onRetry }) {
  const { title, message } = error;

  return (
    <div className="ceremony-error" role="alert">
      <svg
        className="ceremony-error__icon"
        viewBox="0 0 24 24"
        aria-hidden="true"
        focusable="false"
      >
        <circle cx="12" cy="12" r="9.25" fill="none" stroke="currentColor" strokeWidth="1.5" />
        <path d="M12 7.5v6" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" />
        <circle cx="12" cy="16.5" r="1" fill="currentColor" />
      </svg>
      <h1 className="ceremony-error__title">{title}</h1>
      <p className="ceremony-error__message">{message}</p>
      {onRetry && (
        <button type="button" className="ceremony-error__retry" onClick={onRetry}>
          إعادة المحاولة
        </button>
      )}
    </div>
  );
}
